import React from "react";
import successImg from "./success.webp";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

export default function SuccessPage() {
  return (
    <div>
      <Navbar />
      <div className="container text-center">
        <div className="row justify-content-center">
          <div className="col-lg-9 col-md-10" style={{ margin: "5% 0 10% 0" }}>
            <img
              src={successImg}
              width="80%"
              height="auto"
              style={{ maxWidth: "400px", height: "auto" }}
              alt="Success"
            />
            <h1 className="a1">Thank You</h1>
            <p className="a2">
              We have received your inquiry. Our representative will reach out
              to you shortly.
            </p>
            <Link to="/" className="btn btn-primary btn-special-cta">
              Back to Homepage
            </Link>
            {" "}
            <Link
              to="/contact-us"
              className="btn btn-secondary btn-special-cta"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
